export default __webpack_public_path__ + "2b415416a7f31e809fba1e620f2c9514.png";